import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { IDeleteAttachProps } from './IDeleteAttachProps';
import { DeleteAttachModal } from './DeleteAttachModal';

export const DeleteExecutor = createModalExecutor<IDeleteAttachProps>({
    modal: DeleteAttachModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, parentId, rowData, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: parentId ?? '',
        attachId: objId,
        rowData: rowData,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
